// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * Customer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { parse, format } from 'url';
import globalAxios from 'axios';
import { BASE_PATH, BaseAPI, RequiredError } from './base';
/**
 * @export
 * @enum {string}
 */
export var AuthCustomerCreateRequestGenderEnum;
(function (AuthCustomerCreateRequestGenderEnum) {
    AuthCustomerCreateRequestGenderEnum["FEMALE"] = "FEMALE";
    AuthCustomerCreateRequestGenderEnum["MALE"] = "MALE";
    AuthCustomerCreateRequestGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(AuthCustomerCreateRequestGenderEnum || (AuthCustomerCreateRequestGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var AuthCustomerCreateRequestTitleEnum;
(function (AuthCustomerCreateRequestTitleEnum) {
    AuthCustomerCreateRequestTitleEnum["MR"] = "MR";
    AuthCustomerCreateRequestTitleEnum["MRS"] = "MRS";
    AuthCustomerCreateRequestTitleEnum["MISS"] = "MISS";
    AuthCustomerCreateRequestTitleEnum["MS"] = "MS";
    AuthCustomerCreateRequestTitleEnum["DR"] = "DR";
})(AuthCustomerCreateRequestTitleEnum || (AuthCustomerCreateRequestTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var AuthCustomerCreateRequestBrandEnum;
(function (AuthCustomerCreateRequestBrandEnum) {
    AuthCustomerCreateRequestBrandEnum["Lendi"] = "lendi";
    AuthCustomerCreateRequestBrandEnum["Domain"] = "domain";
})(AuthCustomerCreateRequestBrandEnum || (AuthCustomerCreateRequestBrandEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Domain"] = "domain";
})(Brand || (Brand = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerBaseDetailsGenderEnum;
(function (CustomerBaseDetailsGenderEnum) {
    CustomerBaseDetailsGenderEnum["FEMALE"] = "FEMALE";
    CustomerBaseDetailsGenderEnum["MALE"] = "MALE";
    CustomerBaseDetailsGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(CustomerBaseDetailsGenderEnum || (CustomerBaseDetailsGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerBaseDetailsTitleEnum;
(function (CustomerBaseDetailsTitleEnum) {
    CustomerBaseDetailsTitleEnum["MR"] = "MR";
    CustomerBaseDetailsTitleEnum["MRS"] = "MRS";
    CustomerBaseDetailsTitleEnum["MISS"] = "MISS";
    CustomerBaseDetailsTitleEnum["MS"] = "MS";
    CustomerBaseDetailsTitleEnum["DR"] = "DR";
})(CustomerBaseDetailsTitleEnum || (CustomerBaseDetailsTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerBaseDetailsBrandEnum;
(function (CustomerBaseDetailsBrandEnum) {
    CustomerBaseDetailsBrandEnum["Lendi"] = "lendi";
    CustomerBaseDetailsBrandEnum["Domain"] = "domain";
})(CustomerBaseDetailsBrandEnum || (CustomerBaseDetailsBrandEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerCreateRequestGenderEnum;
(function (CustomerCreateRequestGenderEnum) {
    CustomerCreateRequestGenderEnum["FEMALE"] = "FEMALE";
    CustomerCreateRequestGenderEnum["MALE"] = "MALE";
    CustomerCreateRequestGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(CustomerCreateRequestGenderEnum || (CustomerCreateRequestGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerCreateRequestTitleEnum;
(function (CustomerCreateRequestTitleEnum) {
    CustomerCreateRequestTitleEnum["MR"] = "MR";
    CustomerCreateRequestTitleEnum["MRS"] = "MRS";
    CustomerCreateRequestTitleEnum["MISS"] = "MISS";
    CustomerCreateRequestTitleEnum["MS"] = "MS";
    CustomerCreateRequestTitleEnum["DR"] = "DR";
})(CustomerCreateRequestTitleEnum || (CustomerCreateRequestTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerCreateRequestBrandEnum;
(function (CustomerCreateRequestBrandEnum) {
    CustomerCreateRequestBrandEnum["Lendi"] = "lendi";
    CustomerCreateRequestBrandEnum["Domain"] = "domain";
})(CustomerCreateRequestBrandEnum || (CustomerCreateRequestBrandEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerDetailsGenderEnum;
(function (CustomerDetailsGenderEnum) {
    CustomerDetailsGenderEnum["FEMALE"] = "FEMALE";
    CustomerDetailsGenderEnum["MALE"] = "MALE";
    CustomerDetailsGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(CustomerDetailsGenderEnum || (CustomerDetailsGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerDetailsTitleEnum;
(function (CustomerDetailsTitleEnum) {
    CustomerDetailsTitleEnum["MR"] = "MR";
    CustomerDetailsTitleEnum["MRS"] = "MRS";
    CustomerDetailsTitleEnum["MISS"] = "MISS";
    CustomerDetailsTitleEnum["MS"] = "MS";
    CustomerDetailsTitleEnum["DR"] = "DR";
})(CustomerDetailsTitleEnum || (CustomerDetailsTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerDetailsBrandEnum;
(function (CustomerDetailsBrandEnum) {
    CustomerDetailsBrandEnum["Lendi"] = "lendi";
    CustomerDetailsBrandEnum["Domain"] = "domain";
})(CustomerDetailsBrandEnum || (CustomerDetailsBrandEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerDetailsAllOfGenderEnum;
(function (CustomerDetailsAllOfGenderEnum) {
    CustomerDetailsAllOfGenderEnum["FEMALE"] = "FEMALE";
    CustomerDetailsAllOfGenderEnum["MALE"] = "MALE";
    CustomerDetailsAllOfGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(CustomerDetailsAllOfGenderEnum || (CustomerDetailsAllOfGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerDetailsAllOfTitleEnum;
(function (CustomerDetailsAllOfTitleEnum) {
    CustomerDetailsAllOfTitleEnum["MR"] = "MR";
    CustomerDetailsAllOfTitleEnum["MRS"] = "MRS";
    CustomerDetailsAllOfTitleEnum["MISS"] = "MISS";
    CustomerDetailsAllOfTitleEnum["MS"] = "MS";
    CustomerDetailsAllOfTitleEnum["DR"] = "DR";
})(CustomerDetailsAllOfTitleEnum || (CustomerDetailsAllOfTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerDetailsAllOfBrandEnum;
(function (CustomerDetailsAllOfBrandEnum) {
    CustomerDetailsAllOfBrandEnum["Lendi"] = "lendi";
    CustomerDetailsAllOfBrandEnum["Domain"] = "domain";
})(CustomerDetailsAllOfBrandEnum || (CustomerDetailsAllOfBrandEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerUpdateRequestGenderEnum;
(function (CustomerUpdateRequestGenderEnum) {
    CustomerUpdateRequestGenderEnum["FEMALE"] = "FEMALE";
    CustomerUpdateRequestGenderEnum["MALE"] = "MALE";
    CustomerUpdateRequestGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(CustomerUpdateRequestGenderEnum || (CustomerUpdateRequestGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerUpdateRequestTitleEnum;
(function (CustomerUpdateRequestTitleEnum) {
    CustomerUpdateRequestTitleEnum["MR"] = "MR";
    CustomerUpdateRequestTitleEnum["MRS"] = "MRS";
    CustomerUpdateRequestTitleEnum["MISS"] = "MISS";
    CustomerUpdateRequestTitleEnum["MS"] = "MS";
    CustomerUpdateRequestTitleEnum["DR"] = "DR";
})(CustomerUpdateRequestTitleEnum || (CustomerUpdateRequestTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var CustomerUpdateRequestBrandEnum;
(function (CustomerUpdateRequestBrandEnum) {
    CustomerUpdateRequestBrandEnum["Lendi"] = "lendi";
    CustomerUpdateRequestBrandEnum["Domain"] = "domain";
})(CustomerUpdateRequestBrandEnum || (CustomerUpdateRequestBrandEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var Gender;
(function (Gender) {
    Gender["FEMALE"] = "FEMALE";
    Gender["MALE"] = "MALE";
    Gender["UNDISCLOSED"] = "UNDISCLOSED";
})(Gender || (Gender = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var Title;
(function (Title) {
    Title["MR"] = "MR";
    Title["MRS"] = "MRS";
    Title["MISS"] = "MISS";
    Title["MS"] = "MS";
    Title["DR"] = "DR";
})(Title || (Title = {}));
/**
 * CustomerApi - axios parameter creator
 * @export
 */
export var CustomerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get customer profile
         * @param {string} id Customer profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1Auth0CustomersIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling v1Auth0CustomersIdGet.');
            }
            var localVarPath = "/v1/auth0/customers/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieves information for the customer that calls it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CustomersMeGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/v1/customers/me";
            var localVarUrlObj = parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CustomerApi - functional programming interface
 * @export
 */
export var CustomerApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get customer profile
         * @param {string} id Customer profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1Auth0CustomersIdGet: function (id, options) {
            var localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).v1Auth0CustomersIdGet(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Retrieves information for the customer that calls it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CustomersMeGet: function (options) {
            var localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).v1CustomersMeGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * CustomerApi - factory interface
 * @export
 */
export var CustomerApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get customer profile
         * @param {string} id Customer profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1Auth0CustomersIdGet: function (id, options) {
            return CustomerApiFp(configuration).v1Auth0CustomersIdGet(id, options)(axios, basePath);
        },
        /**
         *
         * @summary Retrieves information for the customer that calls it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CustomersMeGet: function (options) {
            return CustomerApiFp(configuration).v1CustomersMeGet(options)(axios, basePath);
        },
    };
};
/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
var CustomerApi = /** @class */ (function (_super) {
    __extends(CustomerApi, _super);
    function CustomerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get customer profile
     * @param {string} id Customer profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.v1Auth0CustomersIdGet = function (id, options) {
        return CustomerApiFp(this.configuration).v1Auth0CustomersIdGet(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Retrieves information for the customer that calls it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.v1CustomersMeGet = function (options) {
        return CustomerApiFp(this.configuration).v1CustomersMeGet(options)(this.axios, this.basePath);
    };
    return CustomerApi;
}(BaseAPI));
export { CustomerApi };
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
export var HealthCheckApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Documents health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/healthcheck";
            var localVarUrlObj = parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
export var HealthCheckApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Documents health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckGet: function (options) {
            var localVarAxiosArgs = HealthCheckApiAxiosParamCreator(configuration).healthcheckGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * HealthCheckApi - factory interface
 * @export
 */
export var HealthCheckApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Documents health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckGet: function (options) {
            return HealthCheckApiFp(configuration).healthcheckGet(options)(axios, basePath);
        },
    };
};
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
var HealthCheckApi = /** @class */ (function (_super) {
    __extends(HealthCheckApi, _super);
    function HealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Documents health check endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    HealthCheckApi.prototype.healthcheckGet = function (options) {
        return HealthCheckApiFp(this.configuration).healthcheckGet(options)(this.axios, this.basePath);
    };
    return HealthCheckApi;
}(BaseAPI));
export { HealthCheckApi };
//# sourceMappingURL=api.js.map